<template>
	<div ref="scrollContainer" class="width-full height-full vertical-scroll">
		<slot></slot>
		<div ref="scrollContainerEnds" style="height: 3px"></div>
	</div>
</template>
<script setup lang="ts">
	import { ref, onMounted } from 'vue'

	const scrollContainer = ref<Element>()
	const scrollContainerEnds = ref<Element>()

	const emits = defineEmits(['endOfScroll'])

	onMounted(() => {
		const intersection = new IntersectionObserver(
			(entries) => {
				const entry = entries[0]
				if (entry.isIntersecting) emits('endOfScroll')
			},
			{
				root: scrollContainer.value,
			}
		)
		intersection.observe(scrollContainerEnds.value!)
	})
</script>
